import Vue from 'vue';
import VueRouter from 'vue-router';
import store from '@/store'
import storage from 'store'
import {ACCESS_TOKEN} from '@/store/mutation-types'
import Utils from "@/js/common/utils";
// import {isAuthPage} from 'js/config/menu-config';

Vue.use(VueRouter);

const initRouter = () => {
  const routerParam = {
    mode: 'history',
    routes: [
      {
        path: '/login',
        name: 'login',
        meta: {title: '教培资金监管'},
        // redirect: '/courseSelection',
        component: () => import('@/components/login/Login')
      },
      {
        path: '/account/login',
        name: 'accountLogin',
        meta: {title: '登录'},
        component: () => import('@/components/login/AccountLogin'),
      },
      {
        path: '/',
        name: 'idx',
        component: () => import('@/layouts/BasicLayout'),
        meta: {title: '首页'},
        redirect: '/organization',
        children: [
          {
            path: '/courseSelection',
            name: 'courseSelection',
            component: () => import('@/views/courseSelection/index'),
            meta: {title: '选课'}
          },
          {
            path: '/courseSelection/courseDetail',
            name: 'courseDetail',
            component: () => import('@/views/courseSelection/detail'),
            meta: {title: '课程详情', hiddenTabbar: true}
          },
          {
            path: '/course/unpaid',
            name: 'unpaid',
            component: () => import('@/views/course/unpaid'),
            meta: {title: '待支付', hiddenTabbar: true}
          },
          {
            path: '/course/reading',
            name: 'reading',
            component: () => import('@/views/course/reading'),
            meta: {title: '课程详情-在读', hiddenTabbar: true}
          },
          {
            path: '/course/auditDetail',
            name: 'auditDetail',
            component: () => import('@/views/course/auditDetail'),
            meta: {title: '课程详情-退费待审核', hiddenTabbar: true}
          },
          {
            path: '/course/returnPremium',
            name: 'returnPremium',
            component: () => import('@/views/course/components/returnPremium'),
            meta: {title: '课程详情-在读', hiddenTabbar: true}
          },
          {
            path: '/course/score',
            name: 'score',
            component: () => import('@/views/course/score'),
            meta: {title: '课程详情-评论', hiddenTabbar: true}
          },
          {
            path: '/course',
            name: 'course',
            component: () => import('@/views/course/course'),
            meta: {title: '课程'}
          },
          {
            path: '/notice',
            name: 'notice',
            component: () => import('@/views/notice/index'),
            meta: {title: '公告', hiddenTabbar: true}
          },
          {
            path: '/notice/noticeDetail',
            name: 'noticeDetail',
            component: () => import('@/views/notice/detail'),
            meta: {title: '公告详情', hiddenTabbar: true}
          },
          {
            path: '/my',
            name: 'my',
            component: () => import('@/views/my/index'),
            meta: {title: '我的'}
          },
          // 纠纷列表
          {
            path: '/my/disputeList',
            name: 'disputeList',
            component: () => import('@/views/dispute/index'),
            meta: {title: '纠纷列表', hiddenTabbar: true}
          },
          // 纠纷详情页面
          {
            path: '/disputeList/detail',
            name: 'disputeListDetail',
            component: () => import('@/views/dispute/disputeDetial'),
            meta: {title: '纠纷详情', hiddenTabbar: true}
          },
          // 纠纷添加页面
          {
            path: '/disputeList/Add',
            name: 'disputeListAdd',
            component: () => import('@/views/dispute/disputeAdd'),
            meta: {title: '纠纷添加', hiddenTabbar: true}
          },
          // 我的意见
          {
            path: '/my/ideaList',
            name: 'ideaList',
            component: () => import('@/views/my/idea/index'),
            meta: {title: '我的意见', hiddenTabbar: true}
          },
          // 纠纷详情页面
          {
            path: '/my/ideaDetail',
            name: 'ideaDetail',
            component: () => import('@/views/my/idea/detail'),
            meta: {title: '意见详情', hiddenTabbar: true}
          },
          // 纠纷添加页面
          {
            path: '/my/ideaAdd',
            name: 'ideaAdd',
            component: () => import('@/views/my/idea/add'),
            meta: {title: '新增意见', hiddenTabbar: true}
          },
          // 修改手机号
          {
            path: '/my/changePhone',
            name: 'changePhone',
            component: () => import('@/views/my/changePhone/index'),
            meta: {title: '修改手机号', hiddenTabbar: true}
          },
          // 账单信息
          {
            path: '/my/bill',
            name: 'changePhone',
            component: () => import('@/views/my/bill/index'),
            meta: {title: '账单信息', hiddenTabbar: true}
          },
          // 机构-课程
          {
            path: '/institutionCourse',
            name: 'institutionCourse',
            component: () => import('@/views/institutionCourse/index'),
            meta: {title: '课程'}
          },
          // 机构-课程详情
          {
            path: '/institutionCourse/detail',
            name: 'institutionCourseDetail',
            component: () => import('@/views/institutionCourse/courseDetail'),
            meta: {title: '课程详情', hiddenTabbar: true}
          },
          // 机构-课程销课
          {
            path: '/institutionCourse/sign',
            name: 'institutionCourseSign',
            component: () => import('@/views/institutionCourse/consumeCourse'),
            meta: {title: '销课', hiddenTabbar: true}
          },
          // 机构-销课记录
          {
            path: '/institutionCourse/signRecord',
            name: 'institutionCourseSignRecord',
            component: () => import('@/views/institutionCourse/signInfo/index'),
            meta: {title: '销课记录', hiddenTabbar: true}
          },
          // 机构-课程销课详情
          {
            path: '/institutionCourse/signDetail',
            name: 'institutionCourseSignDetail',
            component: () => import('@/views/institutionCourse/signInfo/signDetail'),
            meta: {title: '销课详情', hiddenTabbar: true}
          },
          // 机构-课程销课修改
          {
            path: '/institutionCourse/signModify',
            name: 'institutionCourseSignModify',
            component: () => import('@/views/institutionCourse/signInfo/signModify'),
            meta: {title: '销课修改', hiddenTabbar: true}
          },
          // 机构-课程销课修改
          {
            path: '/organization',
            name: 'organization',
            component: () => import('@/views/organization/index'),
            meta: {title: '机构列表'}
          },
          // 机构-课程销课修改
          {
            path: '/organization/detail',
            name: 'organizationDetail',
            component: () => import('@/views/organization/detail'),
            meta: {title: '机构详情', hiddenTabbar: true}
          }
        ]
      }
    ]
  };

  let router = new VueRouter(routerParam);
  // 登录页
  const loginRoutePath = '/login'
  // 首页
  const defaultRoutePath = '/'
  // 免登录白名单
  const whiteList = ['login', 'accountLogin', '/404', '/500']
  router.beforeEach((to, from, next) => {
    if (to.meta && to.meta.title) {
      document.title = to.meta.title;
    } else {
      document.title = '教培资金监管';
    }

    if (storage.get(ACCESS_TOKEN)) {
      // 已登录去登录页，跳转到首页
      if (to.path === loginRoutePath) {
        next({path: defaultRoutePath})
      } else {
        // 如果没有用户信息则查询
        if (Object.keys(store.getters.userInfo).length === 0) {
          store.dispatch('GetInfo').catch(() => {
          })
        }

        //课程菜单进行特殊处理
        if (to.meta && to.path === "/course") {
          const data = Utils.getLocal('identity') || '';
          if (data && JSON.parse(data).value !== 1) {
            next({path: "/institutionCourse", query: {redirect: "/institutionCourse"}});
            return
          }
        }
        next()
      }
    } else {
      if (whiteList.includes(to.name) || whiteList.includes(to.fullPath)) {
        // 在免登录名单，直接进入
        next()
      } else {
        next({path: loginRoutePath, query: {redirect: to.fullPath}})
      }
    }
  });
  router.afterEach(() => {
      document.documentElement.scrollTop = 0;
      document.body.scrollTop = 0;
      let layoutContent = document.querySelector('.h-layout-content');
      if (layoutContent) {
          layoutContent.scrollTop = 0;
      }
  });
  return router;
};

export default initRouter;
